function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { LeafletProvider, addClassName, useLeafletContext } from "@manifesto-tech/react-leaflet-core";
import React, { forwardRef, useState, useEffect, useImperativeHandle, useMemo } from "react";
import { createPortal } from "react-dom";
var DEFAULT_PANES = [
    "mapPane",
    "markerPane",
    "overlayPane",
    "popupPane",
    "shadowPane",
    "tilePane",
    "tooltipPane"
];
function omitPane(obj, pane) {
    var _p = obj[pane], others = _objectWithoutProperties(obj, [
        pane
    ].map(_toPropertyKey));
    return others;
}
function createPane(name, props, context) {
    if (DEFAULT_PANES.indexOf(name) !== -1) {
        throw new Error("You must use a unique name for a pane that is not a default Leaflet pane: ".concat(name));
    }
    if (context.map.getPane(name) != null) {
        throw new Error("A pane with this name already exists: ".concat(name));
    }
    var _props_pane;
    var parentPaneName = (_props_pane = props.pane) !== null && _props_pane !== void 0 ? _props_pane : context.pane;
    var parentPane = parentPaneName ? context.map.getPane(parentPaneName) : undefined;
    var element = context.map.createPane(name, parentPane);
    if (props.className != null) {
        addClassName(element, props.className);
    }
    if (props.style != null) {
        Object.keys(props.style).forEach(function(key) {
            // @ts-ignore
            element.style[key] = props.style[key];
        });
    }
    return element;
}
function PaneComponent(props, forwardedRef) {
    var _useState = _slicedToArray(useState(props.name), 1), paneName = _useState[0];
    var _useState1 = _slicedToArray(useState(null), 2), paneElement = _useState1[0], setPaneElement = _useState1[1];
    useImperativeHandle(forwardedRef, function() {
        return paneElement;
    }, [
        paneElement
    ]);
    var context = useLeafletContext();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var newContext = useMemo(function() {
        return _objectSpreadProps(_objectSpread({}, context), {
            pane: paneName
        });
    }, [
        context
    ]);
    useEffect(function() {
        setPaneElement(createPane(paneName, props, context));
        return function removeCreatedPane() {
            var _pane_remove;
            var pane = context.map.getPane(paneName);
            pane === null || pane === void 0 ? void 0 : (_pane_remove = pane.remove) === null || _pane_remove === void 0 ? void 0 : _pane_remove.call(pane);
            // @ts-ignore map internals
            if (context.map._panes != null) {
                // @ts-ignore map internals
                context.map._panes = omitPane(context.map._panes, paneName);
                // @ts-ignore map internals
                context.map._paneRenderers = omitPane(// @ts-ignore map internals
                context.map._paneRenderers, paneName);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return props.children != null && paneElement != null ? /*#__PURE__*/ createPortal(/*#__PURE__*/ React.createElement(LeafletProvider, {
        value: newContext
    }, props.children), paneElement) : null;
}
export var Pane = /*#__PURE__*/ forwardRef(PaneComponent);
